// extracted by mini-css-extract-plugin
export default {"container":"headerTwo_container__eIgpb","subContainer":"headerTwo_subContainer__YPcuf","arrowContainer":"headerTwo_arrowContainer__lXdIR"};